module.exports = __webpack_public_path__ + "static/img/cable_details.35318e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/igo/cable_details.png
// module id = 569
// module chunks = 0